module.exports = __webpack_public_path__ + "static/IBC-mobile-hero-44daf80001291083027fe1a9d4755c9d.jpg";